import state from './modulePlaceCategoryManagementState.js'
import mutations from './modulePlaceCategoryManagementMutations.js'
import actions from './modulePlaceCategoryManagementActions.js'
import getters from './modulePlaceCategoryManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

